<script lang="ts" setup>
import { RouterView } from 'vue-router';
</script>

<template>
  <main>
    <RouterView />
  </main>
</template>

<style lang="scss" scoped>
</style>
